import styled from 'styled-components';
import { ITextFieldProps } from '../../../types/formTypes';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InputWrapper = styled.div<Pick<ITextFieldProps, 'width'>>`
  position: relative;
  width: auto;
  max-width: ${({ width }) => {
    if (!width) return 'none';
    return width + 'px';
  }};
`;

export const Input = styled.input<Pick<ITextFieldProps, 'error' | 'darkMode'> & { isPasswordField: boolean }>`
  box-sizing: border-box;
  font-family: var(--font-family-altHeader);
  font-feature-settings: var(--font-feature-settings-altHeader);
  font-size: var(--font-size-altHeader-6);
  font-weight: var(--font-weight-altHeader-6);
  letter-spacing: var(--letter-spacing-altHeader-6);
  line-height: var(--line-height-altHeader-6);
  text-transform: var(--text-transform-altHeader);
  border-radius: 0;
  width: 100%;
  height: 48px;
  padding-left: 20px;
  -moz-appearance: textfield;
  padding-right: ${({ isPasswordField }) => {
    if (isPasswordField) return `80px`;
    return `20px`;
  }};
  outline: none;
  border: ${({ error }) => {
    if (error !== undefined) return `1px solid var(--base-color-errorstate)`;
    return `1px solid var(--base-color-darkgrey)`;
  }};
  &:disabled {
    background-color: var(--base-color-lightgrey);
    border: 1px solid transparent;
    outline: none;
  }

  &:focus {
    outline: ${({ darkMode }) => {
      if (darkMode) return `4px solid var(--base-color-lemonchiffon)`;
      return `3px solid var(--base-color-lapislazuli)`;
    }};
  }

  /* remove search decoration */
  &::-webkit-search-decoration,
  &::-webkit-search-cancel-button,
  &::-webkit-search-results-button,
  &::-webkit-search-results-decoration {
    display: none;
  }

  /* remove number decoration */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const ShowHideButton = styled.button`
  position: absolute;
  width: 53px;
  top: 50%;
  margin-top: calc(var(--line-height-overline-1) / 2 * -1);
  right: 20px;
  border: none;
  background: none;
  padding: 0;
  display: block;
  text-align: left;
  cursor: pointer;
  white-space: nowrap;
  color: var(--base-color-black);
`;

export const TextLabel = styled.div<Pick<ITextFieldProps, 'darkMode'>>`
  margin-bottom: 20px;
  color: ${({ darkMode }) => {
    if (darkMode) return `var(--base-color-white)`;
    return `var(--base-color-black)`;
  }};
`;

export const ErrorLabel = styled.div<Pick<ITextFieldProps, 'darkMode'>>`
  margin-top: 20px;
  color: ${({ darkMode }) => {
    if (darkMode) return `var(--base-color-white)`;
    return `var(--base-color-errorstate)`;
  }};
`;
